<p-toast></p-toast>

<div class="enterprise-compare-container">
    <div class="header-section">
        <h1>Comparateur d'Assurance Santé Entreprise</h1>
        <p class="header-subtitle">Déposez vos devis PDF pour extraire et comparer les garanties et les cotisations.</p>
        <button *ngIf="extractions.length > 0" type="button" class="btn-new-comparison" (click)="clearAll()">
            <i class="pi pi-refresh" aria-hidden="true"></i>
            Nouvelle comparaison
        </button>
    </div>

    <!-- Toolbar -->
    <div class="toolbar-section" *ngIf="extractions.length > 0">
        <div class="sort-group">
            <span class="sort-label"><i class="pi pi-filter"></i> Trier par :</span>
            <div class="sort-options" role="group" aria-label="Options de tri">
                <button *ngFor="let opt of sortOptions" type="button" class="sort-pill"
                    [class.sort-pill--active]="selectedSort === opt.value" (click)="changeSort(opt.value)">
                    <i [class]="opt.icon" aria-hidden="true"></i>
                    <span>{{ opt.label }}</span>
                </button>
            </div>
        </div>
        <label class="options-toggle">
            <input type="checkbox" [(ngModel)]="showOptions" />
            <span>Afficher renforts/options</span>
        </label>
        <button type="button" class="toolbar-clear" (click)="clearAll()">
            <i class="pi pi-trash" aria-hidden="true"></i>
            <span>Tout effacer</span>
        </button>
    </div>

    <!-- Upload Section -->
    <p-card class="upload-card">
        <div class="upload-meta-row">
            <div *ngIf="detectedClientName" class="detected-client">
                Client détecté: <strong>{{ detectedClientName }}</strong>
            </div>
        </div>

        <div class="pass-config-row">
            <div class="pass-info-side">
                <i class="pi pi-info-circle info-icon"></i>
                <div class="info-text">
                    <span class="info-title">Configuration des Plafonds</span>
                    <p>Le PASS est utilisé pour calculer les cotisations exprimées en pourcentage du Plafond de la
                        Sécurité Sociale.</p>
                </div>
            </div>
            <div class="pass-input-side">
                <div class="input-field-wrapper">
                    <label for="passValue">Valeur du PASS actuelle</label>
                    <div class="p-inputgroup custom-inputgroup">
                        <span class="p-inputgroup-addon"><i class="pi pi-euro"></i></span>
                        <input pInputText id="passValue" type="number" [(ngModel)]="passValue"
                            placeholder="Ex: 48060" />
                    </div>
                </div>
                <div class="pmss-badge">
                    <span class="pmss-label">PMSS calculé :</span>
                    <span class="pmss-value">{{ (passValue / 12) | number:'1.2-2' }} €</span>
                </div>
            </div>
        </div>

        <div class="upload-actions">
            <p-fileUpload name="pdf_file" mode="basic" chooseLabel="Déposer des Devis (PDF)" [multiple]="true"
                accept="application/pdf" maxFileSize="10000000" (onSelect)="onUpload($event, false)" [auto]="true"
                [disabled]="isLoading">
            </p-fileUpload>

            <p-fileUpload name="pdf_file_client" mode="basic" chooseLabel="Déposer Devis Client (Actuel)"
                [multiple]="true" accept="application/pdf" maxFileSize="10000000" (onSelect)="onUpload($event, true)"
                [auto]="true" [disabled]="isLoading">
            </p-fileUpload>
            <span *ngIf="hasCurrentContractQuote()" class="client-quote-attached-badge">
                <i class="pi pi-check-circle" aria-hidden="true"></i>
                Devis client attaché
            </span>
        </div>

        <div *ngIf="isLoading" class="loading-overlay">
            <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="4" fill="var(--surface-ground)"
                animationDuration=".5s"></p-progressSpinner>
            <p>Analyse des documents en cours avec l'IA...</p>
            <button type="button" class="cancel-loading-btn" (click)="cancelUpload()">
                <i class="pi pi-times-circle" aria-hidden="true"></i>
                Annuler
            </button>
        </div>
    </p-card>

    <!-- Historique des comparaisons (Restauré et synchronisé) -->
    <div class="history-section">
        <div class="history-header">
            <h3><i class="pi pi-history"></i> Historique des comparaisons Entreprise</h3>
            <span class="history-count" *ngIf="comparisonHistory.length > 0">{{ comparisonHistory.length }}
                sauvegarde(s)</span>
        </div>

        <div class="history-list" *ngIf="comparisonHistory.length > 0; else emptyHistory">
            <div class="history-item" *ngFor="let item of comparisonHistory">
                <div class="history-main">
                    <div class="history-client">{{ item.clientName }}</div>
                    <div class="history-meta">
                        {{ item.createdAt | date:'short' }} - {{ item.formulasCount }} formules
                        <span *ngIf="item.includesCurrentContract" class="history-contract-badge">avec contrat
                            actuel</span>
                    </div>
                </div>
                <div class="history-actions">
                    <button type="button" class="history-btn primary" (click)="loadHistoryItem(item)">
                        <i class="pi pi-refresh"></i> Charger
                    </button>
                    <button type="button" class="history-btn danger" (click)="removeHistoryItem(item.id)">
                        <i class="pi pi-trash"></i>
                    </button>
                </div>
            </div>
        </div>
        <ng-template #emptyHistory>
            <div class="empty-history-state">
                <i class="pi pi-info-circle"></i>
                <p>Aucun historique de comparaison entreprise trouvé en base de données.</p>
                <small>Vos prochaines comparaisons seront automatiquement sauvegardées ici.</small>
            </div>
        </ng-template>
    </div>

    <div *ngIf="extractions.length > 0 && !canShowComparisonTable()" class="empty-state">
        <i class="pi pi-info-circle"></i>
        <p *ngIf="hasCurrentContractQuote() && !hasOtherQuotes()">
            Devis client attaché. Ajoutez au moins un autre devis pour afficher le tableau de comparaison.
        </p>
        <p *ngIf="!hasCurrentContractQuote() && hasOtherQuotes()">
            Devis assureurs attachés. Ajoutez le devis client pour afficher le tableau de comparaison.
        </p>
    </div>

    <!-- Comparison Table -->
    <div *ngIf="canShowComparisonTable()" class="comparison-results fadeIn">
        <h2 class="results-title">
            <i class="pi pi-chart-bar"></i>
            Tableau Comparatif
        </h2>
        <div class="comparison-actions">
            <button type="button" class="history-btn" (click)="exportCurrentComparison()">Exporter comparaison
                (JSON)</button>
            <button type="button" class="history-btn" (click)="openSendEmailDialog()">Envoyer par email</button>
            <button type="button" class="history-btn" (click)="openDemandeInfoDialog()" style="background-color: #A102F2; color: white;">
                <i class="pi pi-envelope"></i> Demande d'information
            </button>
            <button type="button" class="history-btn" (click)="openEconomiserEmailDialog()" style="background-color: #9900ff; color: white;">
                <i class="pi pi-envelope"></i> Mail Économiser
            </button>
            <!-- Sauvegarde automatique active, bouton manuel en option discrète si besoin -->
            <button type="button" class="history-btn-text" (click)="saveCurrentComparisonToHistory(true)"
                title="Forcer la sauvegarde">
                <i class="pi pi-save"></i>
            </button>
        </div>
        <p class="limit-info">
            Classement principal: formules de base (hors renforts/options).
        </p>
        <p *ngIf="showOptions && getHiddenOptionFormulasCount() > 0" class="limit-info">
            Renforts/options disponibles non affiches: {{ getHiddenOptionFormulasCount() }}.
        </p>
        <p *ngIf="getHiddenFormulasCount() > 0" class="limit-info">
            Affichage limite a {{ maxVisibleColumns }} devis/formules ({{ getHiddenFormulasCount() }} non affiches).
        </p>

        <div class="table-section">
            <h3 class="table-title">Formules de Base</h3>
            <div class="table-wrapper">
                <table class="comparison-table">
                    <thead>
                        <tr>
                            <th class="criteria-header"></th>
                            <th *ngFor="let formula of getVisibleFormulas()" class="formula-header"
                                [class.highlight-best]="formula.isBestValue">
                                <div class="badge-container">
                                    <span *ngIf="formula.isBestCoverage" class="rank-badge coverage-badge"><i
                                            class="pi pi-shield"></i> Top garanties</span>
                                    <span *ngIf="formula.isBestValue" class="rank-badge value-badge"><i
                                            class="pi pi-check"></i> Recommandé</span>
                                    <span *ngIf="formula.isBestPrice" class="rank-badge price-badge"><i
                                            class="pi pi-tag"></i> Moins cher</span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- Assureur Row -->
                        <tr class="insurer-row">
                            <td class="criteria-cell font-bold">Assureur</td>
                            <td *ngFor="let f of getVisibleFormulas()" class="text-center insurer-name-cell">
                                <div class="insurer-name-text">{{f.insurer}}</div>
                                <div *ngIf="f.isCurrentContract" class="current-contract-badge">Contrat actuel</div>
                            </td>
                        </tr>

                        <!-- Produit Row -->
                        <tr class="product-row">
                            <td class="criteria-cell font-bold">Produit</td>
                            <td *ngFor="let f of getVisibleFormulas()" class="text-center product-cell">
                                <div class="product-name">{{ cleanFormulaName(f.contract) }}</div>
                            </td>
                        </tr>

                        <!-- Niveau Row -->
                        <tr class="formula-row">
                            <td class="criteria-cell font-bold">Niveau</td>
                            <td *ngFor="let f of getVisibleFormulas()" class="text-center formula-level-cell">
                                <div class="formula-level">{{ cleanFormulaName(f.level_name) }}</div>
                            </td>
                        </tr>

                        <!-- Benefits Rows -->
                        <tr *ngFor="let row of displayRows">
                            <td class="criteria-cell font-bold">{{ row.label }}</td>
                            <td *ngFor="let f of getVisibleFormulas()" class="text-center benefit-cell"
                                [ngClass]="getBenefitClass(getDisplayRowValue(f, row))"
                                [innerHTML]="getDisplayRowValue(f, row)">
                            </td>
                        </tr>

                        <!-- Score Row -->
                        <tr>
                            <td class="criteria-cell font-bold">Correspondance</td>
                            <td *ngFor="let f of getVisibleFormulas()" class="text-center font-bold">
                                {{f.coverageScore}} pts
                            </td>
                        </tr>

                        <!-- Premiums Section -->
                        <tr class="price-row">
                            <td class="criteria-cell font-bold">
                                <div class="font-bold">Prix total : Employeur + Salarié</div>
                                <div class="text-xs font-normal text-gray-500">Solo : Salarié seul</div>
                            </td>
                            <td *ngFor="let f of getVisibleFormulas()" class="text-center price-cell">
                                <div class="price-container" *ngIf="f.premiums['isole']; else noPrice">
                                    <span class="price-value">{{f.premiums['isole'] | number:'1.2-2'}} €</span>
                                    <div class="price-period">/ mois</div>
                                </div>
                                <ng-template #noPrice><span class="no-price">-</span></ng-template>
                            </td>
                        </tr>

                        <!-- Duo -->
                        <tr>
                            <td class="criteria-cell">
                                <span class="font-bold">Prix Duo</span> <span class="text-xs text-gray-500">(Salarié +
                                    Conjoint ou + 1 enfant)</span>
                            </td>
                            <td *ngFor="let f of getVisibleFormulas()" class="text-center premium-secondary">
                                {{f.premiums['duo'] ? (f.premiums['duo'] | number:'1.2-2') + ' €' : '-'}}
                            </td>
                        </tr>

                        <!-- Famille -->
                        <tr>
                            <td class="criteria-cell">
                                <span class="font-bold">Prix Famille</span> <span class="text-xs text-gray-500">(Salarié
                                    + Conjoint + Enfants)</span>
                            </td>
                            <td *ngFor="let f of getVisibleFormulas()" class="text-center premium-secondary">
                                {{f.premiums['famille'] ? (f.premiums['famille'] | number:'1.2-2') + ' €' : '-'}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="table-section mt-5" *ngIf="showOptions && getVisibleOptionFormulas().length > 0">
            <h3 class="table-title">Options et Renforts</h3>
            <div class="table-wrapper">
                <table class="comparison-table renfort-table">
                    <thead>
                        <tr>
                            <th class="criteria-header"></th>
                            <th *ngFor="let formula of getVisibleOptionFormulas()" class="formula-header">
                                <div class="badge-container">
                                    <span class="rank-badge option-badge">Option</span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- Assureur Row -->
                        <tr class="insurer-row">
                            <td class="criteria-cell font-bold">Assureur</td>
                            <td *ngFor="let f of getVisibleOptionFormulas()" class="text-center insurer-name-cell">
                                <div class="insurer-name-text">{{f.insurer}}</div>
                            </td>
                        </tr>

                        <!-- Produit Row -->
                        <tr class="product-row">
                            <td class="criteria-cell font-bold">Produit</td>
                            <td *ngFor="let f of getVisibleOptionFormulas()" class="text-center product-cell">
                                <div class="product-name">{{ cleanFormulaName(f.contract) }}</div>
                            </td>
                        </tr>

                        <!-- Niveau Row -->
                        <tr class="formula-row">
                            <td class="criteria-cell font-bold">Niveau</td>
                            <td *ngFor="let f of getVisibleOptionFormulas()" class="text-center formula-level-cell">
                                <div class="formula-level">{{ cleanFormulaName(f.level_name) }}</div>
                            </td>
                        </tr>

                        <!-- Benefits Rows -->
                        <tr *ngFor="let row of displayRows">
                            <td class="criteria-cell font-bold">{{ row.label }}</td>
                            <td *ngFor="let f of getVisibleOptionFormulas()" class="text-center benefit-cell"
                                [ngClass]="getBenefitClass(getDisplayRowValue(f, row))"
                                [innerHTML]="getOptionDeltaValue(f, row)">
                            </td>
                        </tr>

                        <!-- Prix Row (Solo Renfort) -->
                        <tr class="price-row">
                            <td class="criteria-cell font-bold">
                                <div class="font-bold">Prix add. total : Employeur + Salarié</div>
                                <div class="text-xs font-normal text-gray-500">Add. Solo : Salarié seul</div>
                            </td>
                            <td *ngFor="let f of getVisibleOptionFormulas()" class="text-center price-cell">
                                <div class="price-container" *ngIf="f.premiums['isole']; else noPrice">
                                    <span class="price-value">+ {{f.premiums['isole'] | number:'1.2-2'}} €</span>
                                    <div class="price-period">/ mois</div>
                                </div>
                                <ng-template #noPrice><span class="no-price">-</span></ng-template>
                            </td>
                        </tr>

                        <!-- Duo Renfort -->
                        <tr>
                            <td class="criteria-cell">
                                <span class="font-bold">Add. Duo</span> <span class="text-xs text-gray-500">(Salarié +
                                    Conjoint ou + 1 enfant)</span>
                            </td>
                            <td *ngFor="let f of getVisibleOptionFormulas()" class="text-center premium-secondary">
                                {{f.premiums['duo'] ? '+ ' + (f.premiums['duo'] | number:'1.2-2') + ' €' : '-'}}
                            </td>
                        </tr>

                        <!-- Famille Renfort -->
                        <tr>
                            <td class="criteria-cell">
                                <span class="font-bold">Add. Famille</span> <span class="text-xs text-gray-500">(Salarié
                                    + Conjoint + Enfants)</span>
                            </td>
                            <td *ngFor="let f of getVisibleOptionFormulas()" class="text-center premium-secondary">
                                {{f.premiums['famille'] ? '+ ' + (f.premiums['famille'] | number:'1.2-2') + ' €' : '-'}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div *ngIf="extractions.length === 0 && !isLoading" class="empty-state">
        <i class="pi pi-file-pdf"></i>
        <p>Aucun devis à afficher. Veuillez charger des fichiers PDF.</p>
    </div>
</div>

<p-dialog [(visible)]="showEmailDialog" header="Envoyer le comparatif par email" [modal]="true" [draggable]="false"
    [resizable]="false" [style]="{ width: 'min(760px, 96vw)' }" [breakpoints]="{ '960px': '95vw' }"
    (onHide)="closeSendEmailDialog()">
    <div class="enterprise-email-dialog">
        <p class="enterprise-email-dialog-intro">
            Le message reprend le même modèle que pour le comparatif particulier (en-tête Brokins, texte, signature
            conseiller).
            Seul le tableau ci-dessous est celui du comparateur entreprise.
        </p>
        <div class="enterprise-email-recipient-block">
            <label for="entreprise-client-name">Nom du client (pour l’email)</label>
            <input pInputText id="entreprise-client-name" type="text" [(ngModel)]="emailClientDisplayName"
                placeholder="Ex. Marie DURAND ou raison sociale" autocomplete="name" class="enterprise-email-input" />
            <span class="enterprise-email-hint">
                Prérempli lorsque l’IA ou le texte du PDF fournit un interlocuteur, un proposant, un « Nom » ou la
                raison sociale ; vous pouvez le modifier.
            </span>
        </div>
        <div class="enterprise-email-recipient-block">
            <label for="entreprise-civility">Civilité</label>
            <select id="entreprise-civility" class="enterprise-email-select" [(ngModel)]="emailClientCivility">
                <option *ngFor="let o of civilityOptions" [ngValue]="o.value">{{ o.label }}</option>
            </select>
        </div>
        <div class="enterprise-email-preview" *ngIf="emailTablePreview">
            <div [innerHTML]="emailTablePreview"></div>
        </div>
        <div class="enterprise-email-recipient-block">
            <label for="entreprise-recipient-email">Email du destinataire</label>
            <input pInputText id="entreprise-recipient-email" type="email" [(ngModel)]="recipientEmailEntreprise"
                placeholder="client@exemple.fr" autocomplete="email" class="enterprise-email-input" />
        </div>
        <div class="enterprise-email-dialog-actions gap-2">
            <p-button label="Annuler" severity="secondary" [outlined]="true" (onClick)="closeSendEmailDialog()"
                [disabled]="sendingEnterpriseEmail"></p-button>
            <p-button label="Envoyer" icon="pi pi-send" (onClick)="confirmSendEnterpriseEmail('entreprise')"
                [loading]="sendingEnterpriseEmail" [disabled]="sendingEnterpriseEmail" styleClass="p-button-help"></p-button>
        </div>
    </div>
</p-dialog>

<p-dialog [(visible)]="showDemandeInfoDialog" header="Demande d'information entreprise" [modal]="true" [draggable]="false"
    [resizable]="false" [style]="{ width: 'min(660px, 96vw)' }" [breakpoints]="{ '960px': '95vw' }"
    (onHide)="closeDemandeInfoDialog()">
    <div class="enterprise-email-dialog">
        <p class="enterprise-email-dialog-intro">
            Cet email envoie au client la liste des éléments à préparer pour recevoir un comparatif d'assurance
            Mutuelle Santé Groupe. Le client répondra à cet email pour vous fournir ces informations.
        </p>

        <div class="enterprise-email-recipient-block">
            <label for="demande-info-client-name">Nom du client (destinataire)</label>
            <input pInputText id="demande-info-client-name" type="text" [(ngModel)]="demandeInfoClientName"
                placeholder="Ex. Marie DURAND" autocomplete="name" class="enterprise-email-input" />
        </div>
        <div class="enterprise-email-recipient-block">
            <label for="demande-info-civility">Civilité</label>
            <select id="demande-info-civility" class="enterprise-email-select" [(ngModel)]="demandeInfoCivility">
                <option *ngFor="let o of civilityOptions" [ngValue]="o.value">{{ o.label }}</option>
            </select>
        </div>
        <div class="enterprise-email-recipient-block">
            <label for="demande-info-company">Nom de l'entreprise</label>
            <input pInputText id="demande-info-company" type="text" [(ngModel)]="demandeInfoCompanyName"
                placeholder="Ex. SARL DUPONT" autocomplete="organization" class="enterprise-email-input" />
        </div>
        <div class="enterprise-email-recipient-block">
            <label for="demande-info-email">Email du destinataire</label>
            <input pInputText id="demande-info-email" type="email" [(ngModel)]="demandeInfoRecipientEmail"
                placeholder="client@exemple.fr" autocomplete="email" class="enterprise-email-input" />
        </div>

        <div class="enterprise-email-dialog-actions gap-2">
            <p-button label="Annuler" severity="secondary" [outlined]="true" (onClick)="closeDemandeInfoDialog()"
                [disabled]="sendingDemandeInfo"></p-button>
            <p-button label="Envoyer la demande" icon="pi pi-send" (onClick)="confirmSendDemandeInfo()"
                [loading]="sendingDemandeInfo" [disabled]="sendingDemandeInfo" styleClass="p-button-help"></p-button>
        </div>
    </div>
</p-dialog>

<p-dialog [(visible)]="showEconomiserEmailDialog" header="Mail Économiser (Entreprise)" [modal]="true" [draggable]="false"
    [resizable]="false" [style]="{ width: 'min(660px, 96vw)' }" [breakpoints]="{ '960px': '95vw' }"
    (onHide)="closeEconomiserEmailDialog()">
    <div class="enterprise-email-dialog">
        <p class="enterprise-email-dialog-intro">
            Envoyez l'email « ECONOMISER SANS AUCUN RISQUE » à votre prospect avec les informations sur son assurance actuelle.
        </p>

        <div class="enterprise-email-recipient-block">
            <label for="economiser-client-name">Nom du client (destinataire)</label>
            <input pInputText id="economiser-client-name" type="text" [(ngModel)]="economiserClientName"
                placeholder="Ex. Marie DURAND" autocomplete="name" class="enterprise-email-input" />
        </div>
        <div class="enterprise-email-recipient-block">
            <label for="economiser-civility">Civilité</label>
            <select id="economiser-civility" class="enterprise-email-select" [(ngModel)]="economiserCivility">
                <option *ngFor="let o of civilityOptions" [ngValue]="o.value">{{ o.label }}</option>
            </select>
        </div>
        <div class="enterprise-email-recipient-block">
            <label for="economiser-email">Email du destinataire</label>
            <input pInputText id="economiser-email" type="email" [(ngModel)]="economiserRecipientEmail"
                placeholder="client@exemple.fr" autocomplete="email" class="enterprise-email-input" />
        </div>

        <div class="enterprise-email-dialog-actions gap-2">
            <p-button label="Annuler" severity="secondary" [outlined]="true" (onClick)="closeEconomiserEmailDialog()"
                [disabled]="sendingEconomiserEmail"></p-button>
            <p-button label="Envoyer l'email" icon="pi pi-send" (onClick)="confirmSendEconomiserEmail()"
                [loading]="sendingEconomiserEmail" [disabled]="sendingEconomiserEmail" styleClass="p-button-help"></p-button>
        </div>
    </div>
</p-dialog>